/* Royal Mist — Quick View popup (sitewide)
   Intercepts "Choose options" and opens a branded product popup. */
(function () {
  if (window.__rmQuickView) return;
  window.__rmQuickView = true;

  var CSS = [
    '.rmqv-ov{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(20,18,15,.55);opacity:0;transition:opacity .2s ease}',
    '.rmqv-ov.is-open{opacity:1}',
    '.rmqv{width:100%;max-width:1040px;max-height:90vh;overflow:auto;background:#f5f1e6;border-radius:16px;position:relative;display:grid;grid-template-columns:1fr 1.15fr;gap:28px;padding:24px;font-family:Inter,system-ui,sans-serif;transform:translateY(12px);transition:transform .22s ease}',
    '.rmqv-ov.is-open .rmqv{transform:none}',
    '.rmqv-x{position:absolute;top:14px;right:14px;width:32px;height:32px;border-radius:50%;border:1px solid #ddd5c2;background:#fff;color:#14120f;font-size:17px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:3}',
    '.rmqv-x:hover{background:#14120f;color:#f5f1e6;border-color:#14120f}',
    '.rmqv-media{background:#fff;border-radius:12px;display:flex;align-items:center;justify-content:center;padding:26px;min-height:280px}',
    '.rmqv-media img{max-width:100%;max-height:420px;object-fit:contain;display:block}',
    '.rmqv-info{padding:14px 30px 14px 0;display:flex;flex-direction:column}',
    '.rmqv-brand{font-size:10.5px;letter-spacing:1.6px;text-transform:uppercase;color:#8c8677;margin-bottom:8px}',
    '.rmqv-title{font-family:"Playfair Display",Georgia,serif;font-weight:600;font-size:32px;line-height:1.15;color:#14120f;margin:0 0 14px}',
    '.rmqv-stock{display:flex;align-items:center;gap:7px;font-size:13px;color:#3f6b45;margin-bottom:12px}',
    '.rmqv-stock i{width:8px;height:8px;border-radius:50%;background:#3f6b45;display:inline-block}',
    '.rmqv-stock.out{color:#a8402c}.rmqv-stock.out i{background:#a8402c}',
    '.rmqv-price{font-size:19px;color:#14120f;margin-bottom:6px}',
    '.rmqv-price s{color:#8c8677;font-size:15px;margin-left:8px}',
    '.rmqv-ship{font-size:12.5px;color:#6f6a5e;margin-bottom:20px}',
    '.rmqv-ship a{color:#6f6a5e}',
    '.rmqv-optlabel{font-size:12.5px;color:#6f6a5e;margin:0 0 9px}',
    '.rmqv-opts{display:flex;flex-wrap:wrap;gap:9px;margin-bottom:20px}',
    '.rmqv-opt{border:1px solid #ddd5c2;background:#fff;color:#14120f;border-radius:8px;padding:9px 16px;font-size:13px;font-family:inherit;cursor:pointer;transition:.15s}',
    '.rmqv-opt:hover{border-color:#b8912f}',
    '.rmqv-opt.is-on{background:#14120f;color:#f5f1e6;border-color:#14120f}',
    '.rmqv-opt.is-off{opacity:.4;text-decoration:line-through}',
    '.rmqv-qty-w{margin-bottom:22px}',
    '.rmqv-qty{display:inline-flex;align-items:center;border:1px solid #ddd5c2;border-radius:8px;background:#fff;overflow:hidden}',
    '.rmqv-qty button{width:40px;height:42px;border:0;background:transparent;font-size:17px;cursor:pointer;color:#14120f;font-family:inherit}',
    '.rmqv-qty button:hover{background:#efe9da}',
    '.rmqv-qty input{width:52px;height:42px;border:0;text-align:center;font-size:14px;font-family:inherit;background:transparent;color:#14120f}',
    '.rmqv-trust{display:flex;gap:8px;margin-bottom:18px;text-align:center;border-top:1px solid #e4ddcc;border-bottom:1px solid #e4ddcc;padding:15px 0}',
    '.rmqv-trust div{flex:1;font-size:11px;letter-spacing:.2px;color:#3d3a33;line-height:1.4;display:flex;flex-direction:column;align-items:center;gap:7px}',
    '.rmqv-trust svg{width:21px;height:21px;stroke:#b8912f;stroke-width:1.6;fill:none;stroke-linecap:round;stroke-linejoin:round;display:block}',
    '.rmqv-add{width:100%;border:1px solid #14120f;background:transparent;color:#14120f;border-radius:8px;padding:14px;font-size:14px;font-family:inherit;cursor:pointer;transition:.18s}',
    '.rmqv-add:hover{background:#14120f;color:#f5f1e6}',
    '.rmqv-add[disabled]{opacity:.45;cursor:not-allowed}',
    '.rmqv-more{display:inline-block;margin-top:16px;font-size:13px;color:#14120f;text-decoration:none;border-bottom:1px solid #b8912f;padding-bottom:2px}',
    '.rmqv-more:hover{color:#b8912f}',
    '.rmqv-load{grid-column:1/-1;text-align:center;padding:70px 0;color:#6f6a5e;font-size:14px}',
    'body.rmqv-lock{overflow:hidden}',
    '@media(max-width:800px){.rmqv{grid-template-columns:1fr;gap:16px;padding:16px;max-height:92vh}.rmqv-media{min-height:200px;padding:16px}.rmqv-media img{max-height:230px}.rmqv-info{padding:0}.rmqv-title{font-size:24px}}'
  ].join('');

  var style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  var ov = null, cache = {};

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'KES';
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (cur === 'KES') return 'KSh' + n;
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return cur + ' ' + n; }
  }

  function close() {
    if (!ov) return;
    ov.classList.remove('is-open');
    document.body.classList.remove('rmqv-lock');
    var el = ov;
    ov = null;
    setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); }, 200);
  }

  function shell() {
    close();
    ov = document.createElement('div');
    ov.className = 'rmqv-ov';
    ov.innerHTML = '<div class="rmqv" role="dialog" aria-modal="true"><button class="rmqv-x" aria-label="Close">✕</button><div class="rmqv-load">Loading…</div></div>';
    document.body.appendChild(ov);
    document.body.classList.add('rmqv-lock');
    requestAnimationFrame(function () { ov.classList.add('is-open'); });
    ov.addEventListener('click', function (e) {
      if (e.target === ov || e.target.classList.contains('rmqv-x')) close();
    });
    return ov.querySelector('.rmqv');
  }

  function render(box, p) {
    var sel = [], i;
    var first = null;
    for (i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { first = p.variants[i]; break; } }
    if (!first) first = p.variants[0];
    for (i = 0; i < p.options.length; i++) sel[i] = first['option' + (i + 1)];

    function current() {
      for (var k = 0; k < p.variants.length; k++) {
        var v = p.variants[k], ok = true;
        for (var j = 0; j < p.options.length; j++) { if (v['option' + (j + 1)] !== sel[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function valueAvailable(idx, val) {
      for (var k = 0; k < p.variants.length; k++) {
        var v = p.variants[k];
        if (v['option' + (idx + 1)] !== val) continue;
        var ok = true;
        for (var j = 0; j < p.options.length; j++) {
          if (j === idx) continue;
          if (v['option' + (j + 1)] !== sel[j]) { ok = false; break; }
        }
        if (ok && v.available) return true;
      }
      return false;
    }

    var optHtml = '';
    for (i = 0; i < p.options.length; i++) {
      var o = p.options[i];
      var name = (typeof o === 'string') ? o : o.name;
      var vals = (typeof o === 'string') ? p.optionValues : o.values;
      optHtml += '<p class="rmqv-optlabel">' + name + '</p><div class="rmqv-opts" data-oi="' + i + '">';
      for (var q = 0; q < vals.length; q++) {
        optHtml += '<button type="button" class="rmqv-opt" data-val="' + String(vals[q]).replace(/"/g, '&quot;') + '">' + vals[q] + '</button>';
      }
      optHtml += '</div>';
    }

    box.innerHTML =
      '<button class="rmqv-x" aria-label="Close">✕</button>' +
      '<div class="rmqv-media"><img alt="' + String(p.title).replace(/"/g, '&quot;') + '"></div>' +
      '<div class="rmqv-info">' +
        (p.vendor ? '<div class="rmqv-brand">' + p.vendor + '</div>' : '') +
        '<h2 class="rmqv-title">' + p.title + '</h2>' +
        '<div class="rmqv-stock"><i></i><span></span></div>' +
        '<div class="rmqv-price"></div>' +
        '<div class="rmqv-ship"><a href="/policies/shipping-policy">Shipping</a> calculated at checkout.</div>' +
        optHtml +
        '<div class="rmqv-qty-w"><p class="rmqv-optlabel">Quantity</p><div class="rmqv-qty">' +
          '<button type="button" data-step="-1">−</button><input type="text" value="1" inputmode="numeric"><button type="button" data-step="1">+</button>' +
        '</div></div>' +
        '<div class="rmqv-trust">' +
          '<div><svg viewBox="0 0 24 24"><rect x="4" y="10.5" width="16" height="10.5" rx="2"/><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"/></svg>Secure Checkout</div>' +
          '<div><svg viewBox="0 0 24 24"><path d="M12 3l7 3v5.5c0 4.3-2.9 7.6-7 9.5-4.1-1.9-7-5.2-7-9.5V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>Quality Guaranteed</div>' +
          '<div><svg viewBox="0 0 24 24"><path d="M2 15h9V7H2z"/><path d="M11 10h4.6l2.9 3v2H11z"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="16.5" cy="17.5" r="1.8"/></svg>Quick Dispatch</div>' +
        '</div>' +
        '<button class="rmqv-add">Add to cart</button>' +
        '<a class="rmqv-more" href="' + p.url + '">View full details →</a>' +
      '</div>';

    var img = box.querySelector('.rmqv-media img');
    var stock = box.querySelector('.rmqv-stock');
    var stockTxt = stock.querySelector('span');
    var priceEl = box.querySelector('.rmqv-price');
    var addBtn = box.querySelector('.rmqv-add');
    var qtyIn = box.querySelector('.rmqv-qty input');
    var moreLink = box.querySelector('.rmqv-more');

    function paint() {
      var v = current();
      var groups = box.querySelectorAll('.rmqv-opts');
      for (var g = 0; g < groups.length; g++) {
        var gi = parseInt(groups[g].getAttribute('data-oi'), 10);
        var btns = groups[g].querySelectorAll('.rmqv-opt');
        for (var b = 0; b < btns.length; b++) {
          var val = btns[b].getAttribute('data-val');
          btns[b].classList.toggle('is-on', val === sel[gi]);
          btns[b].classList.toggle('is-off', !valueAvailable(gi, val));
        }
      }
      var src = (v && v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]);
      if (src) img.src = (String(src).indexOf('//') === 0 ? 'https:' + src : src).replace(/(\.(jpe?g|png|webp|gif))/i, '_800x$1');
      if (v) {
        priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '');
        stock.classList.toggle('out', !v.available);
        stockTxt.textContent = v.available ? 'In stock' : 'Out of stock';
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
        moreLink.href = p.url + '?variant=' + v.id;
      } else {
        priceEl.textContent = money(p.price);
        stock.classList.add('out');
        stockTxt.textContent = 'Unavailable';
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
      }
    }

    box.addEventListener('click', function (e) {
      var o = e.target.closest ? e.target.closest('.rmqv-opt') : null;
      if (o) {
        var gi = parseInt(o.parentNode.getAttribute('data-oi'), 10);
        sel[gi] = o.getAttribute('data-val');
        paint();
        return;
      }
      var st = e.target.closest ? e.target.closest('[data-step]') : null;
      if (st) {
        var n = parseInt(qtyIn.value, 10) || 1;
        n += parseInt(st.getAttribute('data-step'), 10);
        qtyIn.value = n < 1 ? 1 : n;
        return;
      }
      if (e.target === addBtn) {
        var v = current();
        if (!v || !v.available) return;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: parseInt(qtyIn.value, 10) || 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return refreshDrawer();
        }).then(function () {
          // Close the popup and let the black cart notification do the talking.
          // The side drawer is intentionally NOT opened here.
          close();
        }).catch(function () {
          window.location.href = p.url;
        });
      }
    });

    paint();
  }

  function openDrawer() {
    var comp = document.querySelector('cart-drawer-component');
    var d = comp ? comp.closest('theme-drawer') : null;
    if (d && typeof d.open === 'function') { d.open(); return true; }
    return false;
  }

  function refreshDrawer() {
    return fetch('/?sections=cart-drawer-section', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer-section'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer-component');
        var live = document.querySelector('cart-drawer-component');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function open(handle) {
    var box = shell();
    if (cache[handle]) { render(box, cache[handle]); return; }
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { cache[handle] = p; if (ov) render(box, p); })
      .catch(function () { window.location.href = '/products/' + handle; });
  }

  function handleFrom(el) {
    var a = el.closest('a[href*="/products/"]');
    if (!a) {
      var card = el.closest('product-card, .rmbs-card, .rm-pcard, .card, li, .product-card');
      if (card) a = card.querySelector('a[href*="/products/"]');
    }
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-rmqv-skip]')) return;

    var trigger = t.closest('a, button');
    if (!trigger) return;

    var label = (trigger.textContent || '').trim().toLowerCase();
    // Match any "Choose …" label (options / option / designs / sizes / flavours)
    // so the popup keeps working if the card button copy is reworded.
    var isChoose = label.indexOf('choose ') === 0;
    if (!isChoose && !trigger.closest('quick-add-component')) return;
    if (!isChoose) {
      // Both the Add and Choose buttons live in the DOM at once, so the
      // component's text ALWAYS contains "choose". Read the state attribute
      // instead, otherwise single-variant cards get hijacked into the popup.
      var qa = trigger.closest('quick-add-component');
      if (!qa || qa.getAttribute('data-quick-add-button') !== 'choose') return;
    }

    var handle = handleFrom(trigger);
    if (!handle) return;

    e.preventDefault();
    e.stopPropagation();
    open(handle);
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // Belt and braces: if Horizon's stock quick-add dialog ever gets rendered
  // again (theme update, setting toggled), slam it shut the moment it opens so
  // shoppers only ever see the Royal Mist quick view.
  function killStockQuickAdd() {
    var dlg = document.getElementById('quick-add-dialog');
    if (!dlg || dlg.dataset.rmKilled === '1') return;
    dlg.dataset.rmKilled = '1';

    function shut() {
      try {
        if (typeof dlg.closeDialog === 'function') dlg.closeDialog();
        var native = dlg.querySelector('dialog');
        if (native && native.open) native.close();
      } catch (e) {}
    }

    new MutationObserver(shut).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    var inner = dlg.querySelector('dialog');
    if (inner) new MutationObserver(shut).observe(inner, { attributes: true, attributeFilter: ['open'] });
    shut();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', killStockQuickAdd, { once: true });
  } else {
    killStockQuickAdd();
  }
})();
